// extracted by mini-css-extract-plugin
export default {"page":"oY-z","cartModal":"pY-z","checkout":"qY-z","placeholder":"rY-z","account":"sY-z"};